import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Dashboard } from 'src/app/core/models/lead-campaign';
import { SnackbarService } from 'src/app/shared/components/snackbar/service/snackbar.service';
import { TeamManagementService } from 'src/app/team-management/service/team-management.service';

@Component({
  selector: 'app-lead-home',
  templateUrl: './lead-home.component.html',
  styleUrls: ['./lead-home.component.scss']
})
export class LeadHomeComponent implements OnInit {

  public mock_dashboard: Dashboard = {
    type: 'ACTIVE_CAMPAIGNS',
    title: 'Campanhas em oferta',
    icon: 'percentage',
    values: {
      total: 0,
    },
    action: {
      target: '_blank',
      url: 'https://www.lopes.com.br/'
    }
  };

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private leadsService: TeamManagementService,
    private snackService: SnackbarService
  ) { }

  ngOnInit() {
    this.leadsService.getActiveCampaignsCount().subscribe(resp => {
      if (resp && resp.count) {
        this.mock_dashboard.values.total = resp.count;
      }
      if (!resp) {
        this.mock_dashboard.values.total = 0;
      }
    },
    err => {
      this.snackService.show('Ocorreu um erro ao carregar as campanhas', 'error', 10);
    });
  }

  public routerActived(event: string): void {
    this.router.navigate([`${event}`], { relativeTo: this.activeRouter });
  }

}
